import enIcon from 'assets/uk.svg'
import roIcon from 'assets/romania.svg'
import bgIcon from 'assets/bulgaria.svg'
import Select from 'features/common/components/Select'
import useLanguageSelect from '../../../../../common/hooks/useLanguageSelect'
import {useTranslation} from 'react-i18next'

const LanguageOption = ({label, icon}: {label: string; icon: string}) => {
    return (
        <div className="flex flex-1 items-center gap-7.5 ">
            <img className="h-[1.875rem]" src={icon} alt={label} />
            <div>{label}</div>
        </div>
    )
}

const languages = [
    {
        value: 'en',
        label: 'ENGLISH',
        icon: enIcon,
    },
    {
        value: 'ro',
        label: 'ROMANIAN',
        icon: roIcon,
    },
    {
        value: 'bg',
        label: 'BULGARIAN',
        icon: bgIcon,
    },
] as const

const LanguageSelect = () => {
    const {t} = useTranslation()
    const {language, onChangeLanguage} = useLanguageSelect()
    const chosenOption =
        languages.find((l) => l.value === language) || languages[0]

    return (
        <Select
            value={language}
            onChange={(value: string) => value && onChangeLanguage(value)}
        >
            <Select.Button className="h-[3.75rem] rounded-t-[1.875rem] rounded-b-[1.875rem]">
                <LanguageOption
                    label={t(chosenOption.label)}
                    icon={chosenOption.icon}
                />
            </Select.Button>
            <Select.Options className="rounded-b-[1.875rem]">
                {languages.map((op) =>
                    op.value !== language ? (
                        <Select.Option
                            className="h-[3.75rem]"
                            key={op.value}
                            value={op.value}
                        >
                            <LanguageOption
                                label={t(op.label)}
                                icon={op.icon}
                            />
                        </Select.Option>
                    ) : null,
                )}
            </Select.Options>
        </Select>
    )
}

export default LanguageSelect
